export const HANWHA_LOG_TYPE_OPTIONS = [
  { label: 'Event log', value: 'eventlog' },
  { label: 'System log', value: 'systemlog' },
  { label: 'Access log', value: 'accesslog' },
]

export const HANWHA_EVENT_TYPES_BY_LOG = {
  eventlog: [
    'VideoAnalysis', 'Passing', 'Entering', 'Exiting', 'Appearing',
    'Disappearing', 'MotionDetection', 'NetworkDisconnect', 'FaceDetection',
    'Tampering Detection', 'AlarmInput', 'AlarmOutput', 'AudioDetection',
    'AudioAnalysis', 'VideoLoss', 'VideoLossRelease', 'SceneChange',
    'DefocusDetection', 'FogDetection', 'ShockDetection',
    'TemperatureChangeDetection', 'BoxTemperatureDetection',
    'Body TemperatureDetection', 'MaskDetection',
    'SocialDistancingViolation', 'ParkingDetection', 'MQTTSubscription',
  ],
  systemlog: [
    'PowerOn', 'PowerOff', 'PowerReboot', 'ConfigChange',
    'VideoLossRecordProfileReplace', 'VideoLossRecordProfileRestore',
    'Backup', 'BackupStart', 'BackupEnd', 'NetworkBackupStart',
    'NetworkBackupEnd', 'FWUpdate', 'FactoryReset',
    'HDDFull', 'HDDFail', 'HDDCountChanged', 'HDDNone', 'FanError',
    'FrameFan1Fail', 'FrameFan2Fail', 'FrameFan3Fail', 'FrameFan4Fail',
    'FrameFan1Repair', 'FrameFan2Repair', 'FrameFan3Repair', 'FrameFan4Repair',
    'SDFormat',
    'SDFail', 'SDFull', 'SDInsert', 'SDRemove', 'Network', 'TimeChange',
    'Record', 'ConfigurationBackup', 'ConfigurationRestore', 'NASFormat',
    'NASFail', 'NASFull', 'NASConnect', 'NASDisconnect', 'PlaybackStart',
    'PlaybackEnd', 'SystemUpgrade', 'InternalHDDErase', 'ExternalHDDErase',
    'USBHDDErase', 'USBMemoryErase', 'HDDError', 'RecordingError',
    'Password Change', 'CPUFanFail', 'CPUFanRepair', 'LeftFanFail', 'RightFanFail',
    'RecordFrameDrop', 'AlarmOut1', 'AlarmOut2', 'AlarmOut3', 'AlarmOut4',
    'AlarmOutBeep', 'Net1Connect', 'Net1Disconnect', 'Net2Connect',
    'Net2Disconnect', 'Net3Connect', 'Net3Disconnect', 'Net4Connect',
    'Net4Disconnect', 'RAIDEnable', 'RAIDDisable', 'RAIDBuildStart',
    'RAIDBuildEnd', 'RAIDRebuildStart', 'RAIDRebuildFail', 'RAIDFail',
    'FanStopped', 'MQTTConnection', 'NetCamConnect', 'NetCamDisconnect',
    'AdminLogin', 'AdminLogout', 'UserLogin', 'UserLogout',
    'LocalSetupStart', 'LocalSetupEnd', 'Export', 'RecoverFromPowerFail',
    'AdminAccountBlock', 'UserAccountBlock', 'BatteryFail',
    'DualRecordingDisable', 'DSPDisplayStart',
  ],
  accesslog: [
    'AdminLogin', 'AdminLogout', 'UserLogin', 'UserLogout', 'GuestLogin',
    'GuestLogout', 'Login', 'SessionTimeout',
  ],
}

export const getHanwhaEventTypes = logType =>
  HANWHA_EVENT_TYPES_BY_LOG[logType] || []
